import { useQuery } from '@apollo/client';
import { useClearAccount, useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type { MtBreederOnboardingGetProfileQuery } from '@gql/graphql';

export const MT_BREEDER_ONBOARDING_GET_PROFILE = graphql(`
  query MtBreederOnboardingGetProfile {
    accountMe {
      id
      firstName
      lastName

      birthday
      gender
      language

      address {
        id
        streetNumber
        country
        city
        region
        zip
        street
      }

      imgs(take: 1, where: { type: { equals: PROFILE } }) {
        id
        small
      }

      animals {
        id
      }

      dogBreeder {
        id
        dogsPedigree
        motherRestBetweenLitters
        littersByFemale
        femaleBreedersCount
        dogsConsanguinity
        medicalTestsPerformed
        failedMedicalTestsProtocol
        puppiesBirthPlace
        veterinaryInfo
        displayEmail
        displayPhone
        breedingName
        femaleBreedersCount
        certified
        hkFile
        permissionFiles
        identityFiles
        breedClubFiles
        certificationFile
        hasFinishedOnboarding
        displayName
        agreementNumber
        level
        websiteUrl
        facebookUrl
        spokenLanguages # iso 639-1
        # Fallback for translations below
        breedingName

        imgs {
          id
          small
          type
        }

        translations {
          id
          url
          language
          description
          breederDogsSelection
          dogsActivities
          dogsLivingPlace
          health
          puppiesTraining
          puppiesLivingPlace
          # idealMasterDescription
        }

        breederBreeds {
          id
          dogBreedId
        }

        litters {
          id
        }
      }
    }
  }
`);

export const useGetProfile = () => {
  const { currentAccount, currentAccountType } = useCurrentAccount();
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const { loading, error, data } = useQuery<MtBreederOnboardingGetProfileQuery>(
    MT_BREEDER_ONBOARDING_GET_PROFILE,
    {
      onError: redirectOnTokenErrorHandler,
      skip: currentAccountType !== 'breeder' || !currentAccount,
    },
  );

  return { profileLoading: loading, profileError: error, profile: data?.accountMe };
};
